import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLightbulb, faBolt, faCog, faUserCog, faTimes, faSignOutAlt, faCodeBranch, faHistory, faPencilAlt, faKey, faGlobe, faFileAudio, faList, faRobot, faClock, faCommentDots } from '@fortawesome/free-solid-svg-icons';
import './Userpage.css';
import { useUserAuth } from "../context/UserAuthContext";
import vip1 from './images/vip1.png'
import vip2 from './images/vip2.png'
import vip3 from './images/vip3.png'
import { set } from 'react-hook-form';
import avatar from '../avatar.png'


const Userpage = ({ onClose, showHistory, showSettings, showUpgrade}) => {
  const { user, logOut, signInStatus, userDataLocal, updateUserFirestoreData, needUpdate, setNeedUpdate, userVipLevel, openPricePopup, setOpenPricePopup, setCurrentUpdateReason } = useUserAuth();
  const [avatarNow, setAvatarNow] = useState(avatar);
  const [vipLevelString, setVipLevelString] = useState('Free User');
  const [upgradeBtnTitle, setUpgradeBtnTitle] = useState('Get Nvoice VIP');
  const [usageStatus, setUsageStatus] = useState('10% used');
  const [usageMax, setUsageMax] = useState('10% used');
  const [usageTime, setUsageTime] = useState('10% used');
  const userpageRef = React.useRef(null);
  const [isVisible, setIsVisible] = React.useState(false);
  const [userDataChanged, setUserDataChanged] = useState(false);
  const [userInfo, setUserInfo] = useState(userDataLocal);
  const [expireTime, setExpireTime] = useState();
  const [timeOutData, setTimeOutData] = useState('1 minute');
  const [userName, setUserName] = useState('');

  //2024.04.03
  // 在组件的开始部分添加一个新的状态
  const [isEditingName, setIsEditingName] = useState(false);
  // 添加一个函数来处理编辑标签的点击事件
  const handleEditNameClick = (event) => {
    event.stopPropagation(); // 阻止事件冒泡
    setIsEditingName(true);
  };

  // 添加一个函数来处理输入框的失焦事件
  const handleNameBlur = () => {
    if(userDataLocal.Name != userName){
      setUserDataChanged(true);
    } else {
      setUserDataChanged(false);
    }
    setTimeout(() => {
      setIsEditingName(false);
    }, 2);
  };
    
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (isVisible && userpageRef.current && !userpageRef.current.contains(e.target)) {
        if (userDataChanged) {
          setNeedUpdate(true);
          setCurrentUpdateReason('userPageChanged');
        }
        onClose(); // Close popup
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isVisible, onClose]);

  useEffect(() => {
    const name = userInfo.Name;
    let username = name;
    if (name.includes('@')) {
        username = name.split('@')[0];
    }
    setUserName(username);
  }, [userInfo]);

  useEffect(() => {
    if (userDataChanged) {
      updateUserFirestoreData(userInfo).then(() => {
        // setUserDataChanged(false); // 更新成功后将状态重置
      }).catch(error => {
        console.error("Failed to update user data in Firestore", error);
      });
    }
  }, [userDataChanged]);


  // 组件加载时用userDataLocal初始化用户信息
  // 当组件即将卸载时执行更新
  useEffect(() => {
    setUserInfo(userDataLocal);
    setIsVisible(true);
    return () => {
      // console.log('Userpage unmounting');
      setIsVisible(false);
      // 这个函数会在组件卸载时执行
    };
  }, []);

  //当服务器的用户数据发生变化并且当前用户没有对本地设置进行改动时，更新用户信息
  useEffect(() => {
    if(!userDataChanged){
      setUserInfo(userDataLocal);
      resetUserInfo();//更新用户界面的显示数据
    }
    // if(userDataChanged){
    //   updateUserInformation();
    // }
  }, [userDataLocal]);

  // 根据VIP等级设置头像 upgradeBtnTitle, setUpgradeBtnTitle
  useEffect(() => {
    const avatars = [vip1, vip2, vip3];
    if (userDataLocal.VIPLevel > 0 && userDataLocal.VIPLevel <= 3){
      const date = new Date(userDataLocal.ExpiredTime);
      const formattedDate = date.toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' });
      setExpireTime(formattedDate);
      setAvatarNow(avatars[userDataLocal.VIPLevel - 1] || avatar);
      if (userDataLocal.VIPLevel > 0){
        setVipLevelString('VIP');
        // setUpgradeBtnTitle('Upgrade to Business');
        setUpgradeBtnTitle('Renew payment');
      } 
      // else if (userDataLocal.VIPLevel === 2){
      //   setVipLevelString('Business VIP');
      //   setUpgradeBtnTitle('Renew payment');
      // }
      // setVipLevelString(`VIP${userVipLevel}`);
    } else {
      setAvatarNow(avatar);
      setVipLevelString('Free User');
    }
  }, [userVipLevel]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setUserInfo(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const autoStopTimeOptions = [
    { label: "15 seconds", value: 15000 },
    { label: "30 seconds", value: 30000 },
    { label: "1 minute", value: 60000 },
    { label: "2 minutes", value: 120000 }
    // { label: "5 minutes", value: 300000 },
    // { label: "10 minutes", value: 600000 }
  ];

  function getLabelByValue(value) {
    const option = autoStopTimeOptions.find(option => option.value === value);
    // console.log('option.label:', option.label);
    return option ? option.label : null;
  }

  const resetUserInfo = () => {
    let valueOfAutoStopTime = parseInt(userDataLocal.AutoStopTime);
    setTimeOutData(getLabelByValue(valueOfAutoStopTime) || '1 minute');
    let MAX_USAGE;
    if (userVipLevel === 0) {
      MAX_USAGE = process.env.REACT_APP_MAX_USAGE_FREE;
    } else if (userVipLevel > 0) {
      MAX_USAGE = process.env.REACT_APP_MAX_USAGE_VIP1;
    } 
    // else if (userVipLevel === 2) {
    //   MAX_USAGE = process.env.REACT_APP_MAX_USAGE_VIP2;
    // }
    
    if (signInStatus){
      if (userDataLocal.Usage.time >= 0 ) {
        let time = Math.floor(userDataLocal.Usage.time);
        setUsageStatus(`${time} of ${MAX_USAGE} monthly minutes used`);
        setUsageMax(MAX_USAGE);
        setUsageTime(time);
      } else {
        console.log('usage data error');
      }
    } else {
      setAvatarNow(avatar);
    }
  };

  const signOutAndReset = async () => {
    await logOut();
    resetUserInfo();
    onClose();
    window.location.href = '/login';
  };

  const handleUpgrade = () => {
    // 跳转到会员升级页面
    // window.location.href = '/vip';
    onClose();
    // console.log('Go to Upgrade page');
    showUpgrade();
    // if (!openPricePopup) setOpenPricePopup(true);
    // setTimeout(() => {
    //   onClose();
    // }, 2);
  }

  const handleHistory = () => {
    onClose();
    showHistory();
    // window.location.href = '/history';
  }

  const handleSettings = () => {
    onClose();
    showSettings();
  }

  return (
    <div className={`popup ${isVisible ? 'active' : ''}`} ref={userpageRef}>
      <div className="popup-content">
        <div className="profile">
          <img src={ avatarNow } alt="Avatar" className="avatar" />
          <div className="profile-info">
            <div className="name">
              {!isEditingName && 
                <span>
                  {userName} 
                  <FontAwesomeIcon  
                  icon={faPencilAlt}
                  className="edit-icon"
                  onClick={(event) => handleEditNameClick(event)}
                  />
                </span>
              }

              {isEditingName && 
                <input
                type="text"
                name="Name"
                value={userName}
                onChange={handleInputChange}
                placeholder={userName}
                maxLength="20"
                readOnly={!isEditingName}
                onBlur={handleNameBlur} // 当输入框失去焦点时，结束编辑
                />
              }
              <div className="name-email">{userInfo?.Email||''}</div>
            </div>
          </div>
          <button className="close-btn" onClick={onClose}><FontAwesomeIcon icon={faTimes} className="lighter-icon" /></button>
        </div>
        <hr />

          <button className="info-item button-noborder" style={{cursor:'default'}}>
            <FontAwesomeIcon icon={faCog} className="lighter-icon" /> Current settings&nbsp;&nbsp;
          </button>
        
          <div className="info-item info-item-fontsizeadjust">
            <label><FontAwesomeIcon icon={faUserCog} className="lighter-icon" />Scenario: {userInfo?.PreSet?.defaultSetName||'Default'}</label>
          </div>

          <div className="info-item info-item-fontsizeadjust">
            <label><FontAwesomeIcon icon={faGlobe} className="lighter-icon" />Language: {userInfo?.Language.lan||'English'}</label>
          </div>
          {/* <div className="info-item info-item-fontsizeadjust">
            <label><FontAwesomeIcon icon={faGlobe} className="lighter-icon" />2nd Language: {userInfo?.LanguageOther ? userInfo?.LanguageOther.lan : 'English'}</label>
          </div> */}

          {/* <div className="info-item info-item-fontsizeadjust">
            <label className="gpt-version-label"><FontAwesomeIcon icon={faCodeBranch} className="lighter-icon" />GPT Version: {userInfo?.GPTVersion||'GPT-3.5'}</label>
          </div> */}

          <div className="info-item info-item-fontsizeadjust">
            <label className="gpt-version-label"><FontAwesomeIcon icon={faFileAudio} className="lighter-icon" />Audio Format: {userInfo?.AudioSet||'mp3'}</label>
          </div>

          <div className="info-item info-item-fontsizeadjust">
            <label className="gpt-version-label"><FontAwesomeIcon icon={faRobot} className="lighter-icon" style={{marginLeft:'-3px'}}/>Launch AI by: {userInfo?.Ailaunchmode||'Select'}</label>
          </div>

          <div className="info-item info-item-fontsizeadjust">
            <label className="gpt-version-label"><FontAwesomeIcon icon={faCommentDots} className="lighter-icon" />AI response mode: {userInfo?.AIResponseMode || 'Text'}</label>
          </div>

          <div className="info-item info-item-fontsizeadjust">
            <label className="gpt-version-label"><FontAwesomeIcon icon={faBolt} className="lighter-icon" />Transcribe mode: {userInfo?.TranscriptionMode || 'Real-time'}</label>
          </div>

          {/* <div className="info-item info-item-fontsizeadjust">
            <label><FontAwesomeIcon icon={faLightbulb} className="lighter-icon" />GPT Prompt Content: </label>
            <div className="userpage-tag-container">
              {userDataLocal?.GPTPromptContent || ''}
            </div>
          </div> */}

          {/* <div className="info-item info-item-fontsizeadjust">
            <label><FontAwesomeIcon icon={faKey} className="lighter-icon" />Keywords: </label>
            <div hidden={userDataLocal.Keywords.length===0 || (userDataLocal.Keywords.length===1 && userDataLocal.Keywords[0]==='')} className="userpage-tag-container">
              {userInfo.Keywords.map((keyword, index) => (
                <div key={index} className="userpage-tag">{keyword}</div>
              ))}
            </div>
          </div>

          <div className="info-item info-item-fontsizeadjust">
            <label><FontAwesomeIcon icon={faList} className="lighter-icon" />Summary: </label>
            <div hidden={userDataLocal.SummarySet.length===0 || (userDataLocal.SummarySet.length===1 && userDataLocal.SummarySet[0]==='')} className="userpage-tag-container">
              {userInfo.SummarySet.map((summary, index) => (
                <div key={index} className="userpage-tag">{summary}</div>
              ))}
            </div>
          </div> */}

          <div className="info-item info-item-fontsizeadjust">
            <label><FontAwesomeIcon icon={faClock} className="lighter-icon" />Timeout: {timeOutData}</label>
          </div>

        {/* <hr />
          <button className="info-item button-noborder" onClick={handleHistory} >
            <FontAwesomeIcon icon={faHistory} className="lighter-icon" /> History&nbsp;&nbsp;<FontAwesomeIcon icon={faChevronRight} className="lighter-icon" />
          </button> */}

        <hr />
        {signInStatus && 
          <button className="info-item button-noborder" onClick={signOutAndReset} >
          <FontAwesomeIcon icon={faSignOutAlt} className="lighter-icon" /> Sign out 
          </button> }
        {/*<hr />

         <div class="subscription-card">
          <hr style={{width: '100%'}} />
          <div class="subscription-info">
            <div class="subscription-plan-container">
              <span class="subscription-plan">{vipLevelString}</span>
              {userDataLocal.VIPLevel > 0 && <span class="validity-period">(Expire at: {expireTime})</span>}
            </div>
            <span class="subscription-usage"> {usageStatus}</span>
            <progress value={usageTime} max={usageMax} class="progress-bar"></progress>
          </div>
          <button class="btn-upgrade" onClick={handleUpgrade}>{upgradeBtnTitle}</button>
        </div> */}
        
      </div>
    </div>
  );
};
export default Userpage;
